import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from 'react-select'
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../../helpers/message";
import { formateDate, formateDateApi } from '../../../helpers/formats';

// api
import analiseboletim_api from "../../../api/analiseboletim_api.js";

export default function ModalPesquisaReincidencias({ boletimVistoria, itemPesquisaReincidencias, handleCloseModalReincidencias }) {

    const { register, getValues } = useForm({ mode: "onBlur" });

    const [isLoadingModal, set_isLoadingModal] = useState(false);
    const [list_tableReincidencias, set_list_tableReincidencias] = useState([]);
    const [options_questoesReincidencia, set_options_questoesReincidencia] = useState([]);
    const [questoesReincidencia, set_questoesReincidencia] = useState([])

    const loadOptionsQuestoesReincidencia = () => {
        let _questoes = [];
        boletimVistoria.boletimVistoriaInspecoes[0].boletimVistoriaQuestoes.map(m => {
            _questoes.push({
                identificacao: m.formularioVistoriaQuestao_Identificacao,
                formularioVistoriaQuestao_Id: m.formularioVistoriaQuestao_Id
            })
        });
        set_options_questoesReincidencia(_questoes);
    }

    const handleChangeQuestoesReincidencia = (value) => {
        let _questoes = value.map((m) => m.formularioVistoriaQuestao_Id);
        set_questoesReincidencia(_questoes);
    }

    const handlePesquisarReincidencias = () => {
        let data = getValues();

        if (data.dataInicial.length != 10 || data.dataFinal.length != 10){
            showMessage("Aviso", "Informe o período de pesquisa", 'error', null);
            return;
        }
        
        let json_submit = {
            inicio: formateDateApi(data.dataInicial),
            fim: formateDateApi(data.dataFinal),
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            penalidade_Id: itemPesquisaReincidencias.penalidade_Id,
            formularioVistoriaQuestoes: questoesReincidencia
        }

        set_isLoadingModal(true);
        analiseboletim_api.analiseReincidencias(json_submit).then(result => {
            set_isLoadingModal(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list_tableReincidencias(result.data);
            }
        });
    }

    const handleExtrairPDF = (rowData) => {
        window.open("/empty/impressaovistoria?codigo=" + rowData.boletimVistoria_Id, "blank")
    }

    useEffect(() => {
        loadOptionsQuestoesReincidencia();
    }, [itemPesquisaReincidencias]);

    return (
        <>
            <Modal isOpen={itemPesquisaReincidencias != null} toggle={handleCloseModalReincidencias} size="lg">
                <ModalHeader toggle={handleCloseModalReincidencias}>Consulta de Reincidências</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="3" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Data vistoria inicial</label>
                                <Input className="form-control"
                                    autocomplete="off"
                                    type="date"
                                    name="dataInicial"
                                    innerRef={register({ required: false })}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Data vistoria final</label>
                                <Input className="form-control"
                                    autocomplete="off"
                                    type="date"
                                    name="dataFinal"
                                    innerRef={register({ required: false })}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="8" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Questões Utilizadas na Pesquisa</label>
                                <Select
                                    name="questoesReincidencia"
                                    options={options_questoesReincidencia}
                                    getOptionLabel={o => o.identificacao}
                                    getOptionValue={o => o.formularioVistoriaQuestao_Id}
                                    onChange={(o) => handleChangeQuestoesReincidencia(o)}
                                    value={options_questoesReincidencia.filter(({ formularioVistoriaQuestao_Id }) => questoesReincidencia.filter(f => f == formularioVistoriaQuestao_Id).length > 0)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    isMulti={true}
                                    ref={e => register(
                                        { name: "questoesReincidencia" },
                                        { required: false })
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="4" md="12" sm="12" className="text-center">
                            <br />
                            <Button color="success" type="button" onClick={handlePesquisarReincidencias}><i className="fas fa-search"></i> Consultar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <MaterialTable style={{ minHeight: "auto" }}
                                title="Lista de Respostas"
                                columns={[
                                    { title: 'Situação Análise', field: 'situacaoAnalise' },
                                    { title: 'Data Vistoria', field: 'dataVistoria', render: (rowData) => formateDate(rowData.dataVistoria) },
                                    { title: 'Contratada', field: 'concessionaria' },
                                    { title: 'Fiscal', field: 'usuarioFiscal_Nome' },
                                ]}
                                data={list_tableReincidencias}
                                isLoading={isLoadingModal}
                                options={{
                                    ...table_style,
                                    filtering: false,
                                    exportButton: true
                                }}
                                actions={[
                                    {
                                        icon: 'print',
                                        tooltip: 'Extrair PDF',
                                        onClick: (event, rowData) => handleExtrairPDF(rowData)
                                    }
                                ]}
                                localization={table_translate}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="text-right">
                    <Button color="default" onClick={handleCloseModalReincidencias}> Fechar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
